/**
 * global spinner
 */
import React from "react";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";
import spinner from "@/assets/img/spinner.gif";

const Spinner = ({ className, children, iconClassName }) => {
  if (children) {
    return (
      <div className={twMerge("w-full h-full flex items-center justify-center ", className)}>
        {React.cloneElement(children, {
          className: twMerge("size-full", iconClassName),
        })}
      </div>
    );
  }
  return (
    <div className={twMerge("w-full h-full flex items-center justify-center ", className)}>
      <img src={spinner} className={twMerge("size-8", iconClassName)} />
    </div>
  );
};

Spinner.displayName = "Spinner";
Spinner.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.node,
};

export default Spinner;
